import { buildQuote } from "./utils.js";
export function pricePI(input, rates) {
    const band = rates.limitBands.find((b) => b.limitKes === input.limitOfIndemnityKes);
    const basic = band?.basicPremiumKes ?? 0;
    const levies = basic * (rates.levies.trainingLevyPct + rates.levies.policyHolderFundPct);
    return buildQuote({
        product: "pi",
        ratesVersion: rates.version,
        items: [
            {
                code: "BASIC_PREMIUM",
                label: "Basic Premium",
                amountKes: basic,
            },
        ],
        leviesKes: levies,
        stampDutyKes: rates.stampDutyKes,
    });
}
